// extracted by css-extract-rspack-plugin
export default {"root":"C4VWLs","input-wrapper":"d2QouW","inputWrapper":"d2QouW","price-button":"LMkyG5","priceButton":"LMkyG5"};